import { useMemo } from "react";
import { isClubWide, membershipScopeLabel } from "../../../utils/membershipGroupScope";
import s from "../clinic.module.css";

/**
 * Выбор групп для тарифа/абонемента.
 * allGroups=true → пустой group_ids (все группы).
 */
export default function MembershipGroupScopeField({
  groups = [],
  allGroups,
  groupIds = [],
  onChange,
  disabled = false,
}) {
  const nameById = useMemo(() => {
    const map = {};
    for (const g of groups) {
      if (g?.id) map[g.id] = g.name;
    }
    return map;
  }, [groups]);

  const toggleGroup = (id) => {
    if (disabled) return;
    const set = new Set((groupIds || []).map(String));
    const key = String(id);
    if (set.has(key)) set.delete(key);
    else set.add(key);
    onChange?.({ allGroups: false, groupIds: [...set] });
  };

  const setAll = () => {
    if (disabled) return;
    onChange?.({ allGroups: true, groupIds: [] });
  };

  return (
    <div className={s.membershipGroupScope}>
      <div className={s.membershipGroupScopeModes}>
        <button
          type="button"
          className={
            allGroups ? s.membershipGroupScopeModeOn : s.membershipGroupScopeMode
          }
          disabled={disabled}
          onClick={setAll}
        >
          Все группы
        </button>
        <button
          type="button"
          className={
            !allGroups ? s.membershipGroupScopeModeOn : s.membershipGroupScopeMode
          }
          disabled={disabled || groups.length === 0}
          onClick={() =>
            onChange?.({
              allGroups: false,
              groupIds: groupIds?.length ? groupIds : [],
            })
          }
        >
          Выбранные
        </button>
      </div>
      {!allGroups ? (
        groups.length === 0 ? (
          <p className={s.clientTabMuted}>Сначала создайте группы в разделе «Группы».</p>
        ) : (
          <ul className={s.membershipGroupScopeList}>
            {groups.map((g) => {
              const checked = (groupIds || []).some(
                (id) => String(id) === String(g.id),
              );
              return (
                <li key={g.id}>
                  <label className={s.membershipGroupScopeItem}>
                    <input
                      type="checkbox"
                      checked={checked}
                      disabled={disabled}
                      onChange={() => toggleGroup(g.id)}
                    />
                    <span>{g.name}</span>
                  </label>
                </li>
              );
            })}
          </ul>
        )
      ) : (
        <p className={s.clientTabMuted}>
          Абонемент действует во всех группах клуба.
        </p>
      )}
      {!allGroups && groupIds?.length ? (
        <p className={s.clientTabMuted}>
          {membershipScopeLabel(groupIds, nameById)}
        </p>
      ) : null}
    </div>
  );
}

export function membershipScopeBadge(planOrMembership, groupNameById = {}) {
  const ids = planOrMembership?.group_ids ?? planOrMembership?.plan?.group_ids;
  if (isClubWide(ids)) return "Все группы";
  return membershipScopeLabel(ids, groupNameById);
}
